
import HomeOutlined from '@mui/icons-material/HomeOutlined'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { Avatar, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography,Collapse, useTheme, Badge } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { tokens } from '../../themes/themes';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import DiscountIcon from '@mui/icons-material/Discount';
import MapIcon from '@mui/icons-material/Map';
import CableIcon from '@mui/icons-material/Cable';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import Groups2Icon from '@mui/icons-material/Groups2';
import BallotIcon from '@mui/icons-material/Ballot';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import usePermisos from '../../hooks/usePermisos';

const Sidebar = ({user,openDrawer,countNotifiTk}) => {
  const [openCorporativo, setOpenCorporativo] = useState(false);
  const handleClickCorporativo = () => setOpenCorporativo(!openCorporativo);
  const [openGobierno, setOpenGobierno] = useState(false);
  const handleClickGobierno = () => setOpenGobierno(!openGobierno);
  const [openPlanillas, setOpenPlanillas] = useState(false);
  const handleClickPlanillas = () => setOpenPlanillas(!openPlanillas);
  const [openFibraOptica, setOpenFibraOptica] = useState(false);
  const handleClickFibraOptica = () => setOpenFibraOptica(!openFibraOptica);
  const [openRadioEnlace, setOpenRadioEnlace] = useState(false);
  const handleClickRadioEnlace = () => setOpenRadioEnlace(!openRadioEnlace);
  const [openAdmTicket, setOpenAdmTicket] = useState(false);
  const handleClickAdmTicket = () => setOpenAdmTicket(!openAdmTicket);
  const [openAdministrador, setOpenAdministrador] = useState(false);
  const handleClickAdministrador = () => setOpenAdministrador(!openAdministrador);
  const [openAnalitica, setOpenAnalitica] = useState(false);
  const handleClickAnalitica = () => setOpenAnalitica(!openAnalitica);
  const [openAsesor, setOpenAsesor] = useState(false);
  const handleClickAsesor = () => setOpenAsesor(!openAsesor);
  const permisos = usePermisos()
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isDarkMode = theme.palette.mode === 'dark';
  const styleSelect = { 
    background: isDarkMode 
      ? 'linear-gradient(90deg, rgba(100, 181, 246, 0.15) 0%, rgba(3, 100, 255, 0.25) 100%)' 
      : 'linear-gradient(90deg, rgba(3, 100, 255, 0.08) 0%, rgba(3, 100, 255, 0.15) 100%)',
    borderLeft: `4px solid ${isDarkMode ? '#64B5F6' : '#0364ff'}`,
    borderRadius: '0 10px 10px 0',
    boxShadow: isDarkMode 
      ? '0 2px 8px rgba(100, 181, 246, 0.15)' 
      : '0 2px 8px rgba(3, 100, 255, 0.1)',
    '& .MuiListItemIcon-root': {
      color: isDarkMode ? '#64B5F6 !important' : '#0364ff !important',
      transform: 'scale(1.08)'
    },
    '& .MuiListItemText-primary': {
      color: isDarkMode ? '#90caf9 !important' : '#0364ff !important',
      fontWeight: '600 !important'
    }
  }
  const {pathname} = useLocation();
  const ItemList = ({info}) => (
    <ListItem
      disablePadding
      sx={[{
        width: openDrawer ? '100%' : '90%',
        marginTop: openDrawer && info.primary && -2,
        marginLeft: pathname === info.path ? 0 : 1,
        marginBottom: 0.3,
        paddingLeft: openDrawer && info.collapse && 4,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        borderRadius: '0 10px 10px 0',
        '&:hover':{
          background: isDarkMode 
            ? 'linear-gradient(90deg, rgba(100, 181, 246, 0.08) 0%, rgba(100, 181, 246, 0.12) 100%)' 
            : 'linear-gradient(90deg, rgba(3, 100, 255, 0.05) 0%, rgba(3, 100, 255, 0.08) 100%)',
          borderLeft: `3px solid ${isDarkMode ? 'rgba(100, 181, 246, 0.5)' : 'rgba(3, 100, 255, 0.3)'}`,
          transform: 'translateX(2px)',
          '& .MuiListItemIcon-root': {
            color: isDarkMode ? '#90caf9' : '#0364ff',
            transform: 'scale(1.05)'
          },
          '& .MuiListItemText-primary': {
            color: isDarkMode ? '#90caf9' : '#0364ff',
            fontWeight: '500'
          }
        }
      },pathname === info.path ? styleSelect:{color: isDarkMode ? '#b0b0b0' : '#6b7280'}
      ]}
      className={`${!openDrawer && info.collapse && 'textPadding' }`}
    >
      <ListItemButton 
        onClick={()=>{navigate(info.path)}}
        sx={{
          borderRadius: '0 10px 10px 0',
          py: 0.75,
          px: 1,
          transition: 'all 0.2s ease'
        }}
      >
        <ListItemIcon sx={{
          marginLeft: 0.5, 
          minWidth: 36,
          color: pathname === info.path 
            ? (isDarkMode ? '#64B5F6' : '#0364ff') 
            : (isDarkMode ? '#b0bec5' : '#6b7280'),
          transition: 'all 0.3s ease',
          '& svg': {
            fontSize: '1.3rem'
          }
        }}>
          {info.icon &&(
            info.icon
          )}
        </ListItemIcon>
        <ListItemText 
          primary={info.name} 
          className={`${!openDrawer && 'hidden' } textSide`}
          sx={{ 
            '& .MuiListItemText-primary': { 
              color: pathname === info.path
                ? (isDarkMode ? '#90caf9' : '#0364ff')
                : (isDarkMode ? '#e0e0e0' : '#374151'),
              fontSize: '0.85rem',
              fontWeight: pathname === info.path ? '600' : '400',
              transition: 'all 0.2s ease'
            } 
          }}
        />
        {info.name === 'Tickets' && (
          <>
            <Badge
              className={`${!openDrawer && 'hidden' } textSide`}
              sx={{position: 'absolute', right: 30,
                '& span':{
                  '&.MuiBadge-badge':{
                    background: '#e01010',
                    color:'white',
                    fontWeight: 'bold',
                    fontSize: 12
                  }
                }
              }}
              badgeContent={countNotifiTk}
            />
            <Badge
              className='textSideHide'
              variant="dot"
              sx={{marginLeft: -3,
                '& span':{
                  '&.MuiBadge-badge':{
                    background: '#e01010',
                    color:'white',
                  }
                }
              }}
              badgeContent={countNotifiTk}
            />
          </>
        )}
      </ListItemButton>
    </ListItem>
  );
  const CollapseItemsList = ({info}) => (
    <ListItem 
      disablePadding 
      sx={[{
        marginLeft: 1,
        marginBottom: 0.3,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        borderRadius: '0 10px 10px 0',
        '&:hover':{
          background: isDarkMode 
            ? 'linear-gradient(90deg, rgba(100, 181, 246, 0.08) 0%, rgba(100, 181, 246, 0.12) 100%)' 
            : 'linear-gradient(90deg, rgba(3, 100, 255, 0.05) 0%, rgba(3, 100, 255, 0.08) 100%)',
          transform: 'translateX(2px)',
          '& .MuiListItemIcon-root': {
            color: isDarkMode ? '#90caf9' : '#0364ff',
            transform: 'scale(1.05)'
          },
          '& .MuiListItemText-primary': {
            color: isDarkMode ? '#90caf9' : '#0364ff',
            fontWeight: '500'
          }
        }
      }, pathname === info.path ? styleSelect:{color: isDarkMode ? '#b0b0b0' : '#6b7280'}]}
    >
        <ListItemButton 
          onClick={()=>info.onClick()}
          sx={{
            borderRadius: '0 10px 10px 0',
            py: 0.75,
            px: 1,
            transition: 'all 0.2s ease'
          }}
        >
          <ListItemIcon sx={{
            marginLeft: 0.5,
            minWidth: 36,
            color: isDarkMode ? '#b0bec5' : '#6b7280',
            transition: 'all 0.3s ease',
            '& svg': {
              fontSize: '1.3rem'
            }
          }}>
            {info.icon &&(
              info.icon
            )}
          </ListItemIcon>
          <ListItemText 
            primary={info.name} 
            className={`${!openDrawer && 'hidden' } textSide`}
            sx={{ 
              '& .MuiListItemText-primary': { 
                color: isDarkMode ? '#e0e0e0' : '#374151',
                fontSize: '0.85rem',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              } 
            }}
          />
          {info.onRef ? 
            <ExpandLess 
              className={`${!openDrawer && 'hidden' } textSide`} 
              sx={{
                color: isDarkMode ? '#b0bec5' : '#6b7280',
                transition: 'transform 0.3s ease'
              }} 
            /> : 
            <ExpandMore 
              className={`${!openDrawer && 'hidden' } textSide`} 
              sx={{
                color: isDarkMode ? '#b0bec5' : '#6b7280',
                transition: 'transform 0.3s ease'
              }} 
            />
          }
        </ListItemButton>
      </ListItem>
  )

  return (
    <Box
        className="relative duration-300"
        sx={{
          width: openDrawer ? 289 : 100,
          background: colors.siderbar.background,
          display:{xs: 'none', lg: 'block'}
        }}
      >
        <Box className="pt-1 h-89 w-full sidebarEsp">
          <Box className="flex gap-x-4 items-center">
            <img
              src={theme.palette.mode === "dark" ? "/img/Zeta-white.png" : "/img/Zeta-black.png"}
              className={`cursor-pointer duration-500 ml-3 mt-1 ${
                openDrawer ? "rotate-[360deg]" : 'sideImage'
              }`}
              style={{height:35}}
            />
            <Typography
              className={`text-white origin-left font-medium text-xl duration-200 ${
                !openDrawer && "scale-0"
              }`}
            >
              -
            </Typography>
          </Box>
          <Box sx={{display: 'flex', alignItems: 'center'}} className='ml-6 mt-6'>
              <Avatar src={user?.foto_p || '/img/default-profile'} sx={{width:50, height: 50}} />
              <Typography
                className={`origin-left font-medium text-sm duration-200 ml-3 text-center ${!openDrawer && 'hidden' } textSide`}
                sx={{color: isDarkMode ? '#e0e0e0' : '#333'}}
              >
                {user?.nombre_p || ''}
              </Typography>
          </Box>
          <Box p={1} sx={{height: '78vh',overflow: 'auto',overflowX:'hidden'}} className='side'>
            {user?.razonSocial_p === 'Enlace' ? (
              <List>
                <ItemList info={{path: '/procesos', name: 'Procesos', icon: <BallotIcon />}} key='procesos' />
              </List>
            ) : (user?.razonSocial_p && user?.razonSocial_p !== 'Asesor') ? (
              <List>
              <ItemList info={{path: '/', name: 'Dashboard', primary: true, icon: <HomeOutlined />}} key='dashboard' />
              <ItemList info={{path: '/tickets', name: 'Tickets', icon: <ConfirmationNumberIcon />}} key='ticket' />
              { permisos['preTicket.NubiGetAll'] && (
                <ItemList info={{path: '/pretickets', name: 'Pre-Tickets', icon: <ConfirmationNumberIcon />}} key='preticket' />
              )}
              { permisos['tabla_ticket_calidad'] && (
                <ItemList info={{path: '/tickets-calidad', name: 'Tickets Calidad', icon: <AssignmentTurnedInIcon />}} key='ticketscalidad' />
              )}
              <ItemList info={{path: '/contactos', name: 'Potenciales clientes', icon: <Groups2Icon />}} key='contactos' />
              <ItemList info={{path: '/tabla/consultas', name: 'Consultas', icon: <Groups2Icon />}} key='tablaconsultas' />
              <ItemList info={{path: '/pre/servicios', name: 'Pre-Servicios', icon: <PersonPinCircleIcon />}} key='tratos' />
              {permisos['contactos.corporativo.getAll'] && (
                <>
                  <CollapseItemsList info={{path: '/corporativos', name: 'Corporativos', onClick:handleClickCorporativo, onRef:openCorporativo, icon: <FolderIcon />  }} />
                  <Collapse in={openCorporativo} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ItemList info={{path: '/tabla/consultas/corporativos', name: 'Consultas', collapse: true, icon: <DiscountIcon />}} key='corportativosconsult' />
                      <ItemList info={{path: '/contactos/corporativos', name: 'Potenciales Clientes', collapse: true, icon: <Groups2Icon />}} key='corportativos' />
                    </List>
                  </Collapse>
                </>
              )}
              {permisos['contactos.gobierno.getAll'] && (
                <>
                  <CollapseItemsList info={{path: '/gobierno', name: 'Gobierno', onClick:handleClickGobierno, onRef:openGobierno, icon: <FolderIcon />  }} />
                  <Collapse in={openGobierno} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ItemList info={{path: '/tabla/consultas/gobierno', name: 'Consultas', collapse: true, icon: <DiscountIcon />}} key='gobiernoconsult' />
                      <ItemList info={{path: '/contactos/gobierno', name: 'Potenciales Clientes', collapse: true, icon: <Groups2Icon />}} key='gobierno' />
                    </List>
                  </Collapse>
                </>
              )}
              { (permisos['autorizar_bonificacion_nivel1'] || permisos['autorizar_bonificacion_nivel2'] || permisos['autorizar_bonificacion_nivel3']) && (
                <ItemList info={{path: '/pre/servicios/pendientes', name: 'Autorizaciones Pendientes', icon: <PersonPinCircleIcon />}} key='pretratos' />
              )}
              {(permisos['cierreTicket.NubiABM'] || permisos['saiSoftlandNubi.ABM'] || permisos['motivoticket.abmNubi'] || permisos['plantillaEmailNubi.ABM'] || permisos['rechazo_da']) && (
                <>
                  <CollapseItemsList info={{path: '/plantillas', name: 'Plantillas', onClick:handleClickPlanillas, onRef:openPlanillas, icon: <FolderIcon />  }} />
                  <Collapse in={openPlanillas} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {permisos['motivoticket.abmNubi'] &&(
                        <ItemList info={{path: '/plantilla/motivos', name: 'Plantillas Ticket', collapse: true, icon: <DescriptionIcon />}} key='plantillaticket' />
                      )}
                      {permisos['cierreTicket.NubiABM'] &&(
                        <ItemList info={{path: '/plantilla/cierreticket', name: 'Cierre Ticket', collapse: true, icon: <AssignmentTurnedInIcon />}} key='cierreticket' />
                      )}
                      {permisos['saiSoftlandNubi.ABM'] &&(
                        <ItemList info={{path: '/plantilla/bonificaciones', name: 'Bonificaciones', collapse: true, icon: <DiscountIcon />}} key='bonificaciones' />
                      )}
                      {permisos['plantillaEmailNubi.ABM'] &&(
                        <ItemList info={{path: '/plantilla/emails', name: 'Plantilla Email', collapse: true, icon: <MarkAsUnreadIcon />}} key='emails' />
                      )}
                      {permisos['plantillaEmailNubi.ABM'] &&(
                        <ItemList info={{path: '/administrar/templates-email', name: 'Editor de Templates', collapse: true, icon: <MarkAsUnreadIcon />}} key='templatesEmail' />
                      )}
                      {permisos['rechazo_da'] &&(
                        <ItemList info={{path: '/plantilla/rechazo-da', name: 'Rechazo Débito Automático', collapse: true, icon: <MoneyOffIcon />}} key='rechazoDA' />
                      )}
                    </List>
                  </Collapse>
                </>
              )}
              <ItemList info={{path: '/reports', name: 'Reportes', icon: <AnalyticsIcon />}} key='reports' />
              <ItemList info={{path: '/equipamientos/tabla', name: 'Equipamiento', icon: <AnalyticsIcon />}} key='equipamientotabla' />
              <ItemList info={{path: '/recordatorios', name: 'Recordatorios', icon: <AnalyticsIcon />}} key='recordatorios' />
              {(permisos['tipoTicket.nubiABM'] || permisos['hashtag.NubiABM'] || permisos['ticket.detProblema.ABM'] || permisos['motivoCancelarPreTicket.NubiABM'] || permisos['abm.alert.date.sales'] ) && (
                <>
                  <CollapseItemsList info={{path: '/administrar', name: 'Administrar Ticket', onClick:handleClickAdmTicket, onRef:openAdmTicket, icon: <DisplaySettingsIcon />  }} />
                  <Collapse in={openAdmTicket} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {permisos['tipoTicket.nubiABM'] &&(
                        <>
                          <ItemList info={{path: '/administrar/tipo-ticket', name: 'Tipo', collapse: true, icon: <MapIcon />}} key='tipoTicket' />
                          <ItemList info={{path: '/administrar/sub-tipo-ticket', name: 'Sub-Tipo', collapse: true, icon: <MapIcon />}} key='subTipoTicket' />
                          <ItemList info={{path: '/administrar/nivel-administrativo', name: 'Nivel Administrativo', collapse: true, icon: <MapIcon />}} key='nivelAdministrativo' />
                          <ItemList info={{path: '/administrar/motivo-baja', name: 'Motivo de Baja', collapse: true, icon: <MapIcon />}} key='motivoDeBaja' />
                          <ItemList info={{path: '/administrar/sub-motivo-baja', name: 'Sub-Motivo-Baja', collapse: true, icon: <MapIcon />}} key='subMotivoBaja' />
                          <ItemList info={{path: '/administrar/sub-cierre-ticket', name: 'Sub-Cierre', collapse: true, icon: <MapIcon />}} key='subCierreTicket' />
                        </>
                      )}
                      { permisos['hashtag.NubiABM'] &&(
                        <ItemList info={{path: '/administrar/tags', name: 'Tags', collapse: true, icon: <MapIcon />}} key='tags' />
                      )}
                      {permisos['ticket.detProblema.ABM'] && (
                        <>
                          <ItemList info={{path: '/administrar/articulo-falla', name: 'Segmento Detalle Adicional', collapse: true, icon: <MapIcon />}} key='articuloFalla' />
                          <ItemList info={{path: '/administrar/problematica', name: 'Problematica', collapse: true, icon: <MapIcon />}} key='problematica' />
                          <ItemList info={{path: '/administrar/solucion-tecnica', name: 'Solucion Tecnica', collapse: true, icon: <MapIcon />}} key='solucionTecnica' />
                        </>
                      )}
                      {permisos['motivoCancelarPreTicket.NubiABM'] && (
                        <ItemList info={{path: '/administrar/email-invalido', name: 'Motivo Correo Invalido', collapse: true, icon: <MapIcon />}} key='emailInvalido' />
                      )}
                      {permisos['abm.alert.date.sales'] && (
                        <ItemList info={{path: '/administrar/alerta-feriados-terceriarizada', name: 'Alerta de Feriados', collapse: true, icon: <MapIcon />}} key='alertdates' />
                      )}
                    </List>
                  </Collapse>
                </>
              )}
              {permisos['fibraNav.nubicom.getAll'] && (
                <>
                  <CollapseItemsList info={{path: '/fibraoptica', name: 'Fibra Optica', onClick:handleClickFibraOptica, onRef:openFibraOptica, icon: <CableIcon />  }} />
                  <Collapse in={openFibraOptica} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ItemList info={{path: '/fibra-optica/naps', name: 'Tabla Naps', collapse: true, icon: <MapIcon />}} key='fibratabla' />
                      {/* <ItemList info={{path: '/fibra-optica/zonas', name: 'Tabla Zonas', collapse: true, icon: <MapIcon />}} key='fibratablazonas' /> */}
                      {/* <ItemList info={{path: '/fibra-optica/historial/kmz', name: 'Historial KMZ', collapse: true, icon: <MapIcon />}} key='fibrahistorial' /> */}
                      <ItemList info={{path: '/fibra-optica/rango/cobertura', name: 'Tabla Cobertura', collapse: true, icon: <MapIcon />}} key='fibratablacobertura' />
                      <ItemList info={{path: '/fibra-optica/mapa', name: 'Cobertura Naps', collapse: true, icon: <MapIcon />}} key='fibramapa' />
                      <ItemList info={{path: '/fibra-optica/mapa-total', name: 'Cobertura Naps Total', collapse: true, icon: <MapIcon />}} key='fibramapatotal' />
                    </List>
                  </Collapse>
                </>
              )}
              {permisos['radioEnlace.nubicom.kmz'] && (
                <>
                  <CollapseItemsList info={{path: '/radio-enlace', name: 'Radio Enlace', onClick:handleClickRadioEnlace, onRef:openRadioEnlace, icon: <CableIcon />  }} />
                  <Collapse in={openRadioEnlace} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ItemList info={{path: '/radio-enlace/tabla', name: 'Tabla Paneles', collapse: true, icon: <MapIcon />}} key='radioEnlaceTabla' />
                      <ItemList info={{path: '/radio-enlace/historial/kmz', name: 'Historial KMZ', collapse: true, icon: <MapIcon />}} key='historyKmz' />
                    </List>
                  </Collapse>
                </>
              )}
              {( permisos['rol.All'] || permisos['usuarios.abm'] || permisos['grupo.abm']) &&(
                <>
                  <CollapseItemsList info={{path: '/administrador', name: 'Administrador', onClick:handleClickAdministrador, onRef:openAdministrador, icon: <AdminPanelSettingsIcon />  }} />
                  <Collapse in={openAdministrador} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      { permisos['rol.All'] && (
                        <ItemList info={{path: '/administrador/permisos', name: 'Permisos', collapse: true, icon: <MapIcon />}} key='admPermisos' />
                      )}
                      {(permisos['usuarios.abm'] || permisos['grupo.abm']) && (
                        <ItemList info={{path: '/administrador/grupos', name: 'Grupos Adm', collapse: true, icon: <GroupsIcon />}} key='admGrupos' />
                      )}
                      {(permisos['procesos.updated'] || permisos['procesos.created']) && (
                        <ItemList info={{path: '/tabla/procesos', name: 'Tabla Procesos', collapse: true, icon: <BallotIcon />}} key='tablaProcesos' />
                      )}
                    </List>
                  </Collapse>
                </>
              )}
              {( permisos['analitica.usuarioId'] || permisos['analitica.general'] || permisos['mitrol_reporteria']) &&(
                <>
                  <CollapseItemsList info={{path: '/analitica', name: 'Analítica', onClick:handleClickAnalitica, onRef:openAnalitica, icon: <AdminPanelSettingsIcon />  }} />
                  <Collapse in={openAnalitica} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      { permisos['analitica.usuarioId'] && (
                        <ItemList info={{path: '/analitica/personal', name: 'Personal', collapse: true, icon: <MapIcon />}} key='anaPersonal' />
                      )}
                      {permisos['analitica.general'] && (
                        <ItemList info={{path: '/analitica/general', name: 'General', collapse: true, icon: <GroupsIcon />}} key='anaGeneral' />
                      )}
                      {permisos['mitrol_reporteria'] && (
                        <ItemList info={{path: '/analitica/mitrol', name: 'Mitrol', collapse: true, icon: <SupportAgentIcon />}} key='anaGeneral' />
                      )}
                    </List>
                  </Collapse>
                </>
              )}
              {( permisos['asesores.NubiGetAll'] || permisos['asesores.NubiABM']) &&(
                <>
                  <CollapseItemsList info={{path: '/asesores', name: 'Asesores', onClick:handleClickAsesor, onRef:openAsesor, icon: <AdminPanelSettingsIcon />  }} />
                  <Collapse in={openAsesor} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ItemList info={{path: '/asesores/personal', name: 'Personal', collapse: true, icon: <MapIcon />}} key='asesorPersonal' />
                      <ItemList info={{path: '/asesores/novedades', name: 'Novedades', collapse: true, icon: <MapIcon />}} key='asesorNovedades' />
                      <ItemList info={{path: '/asesores/objetivos', name: 'Objetivos', collapse: true, icon: <MapIcon />}} key='asesorObjetivos' />
                      <ItemList info={{path: '/asesores/analitica/individual', name: 'Analítica Individual', collapse: true, icon: <AnalyticsIcon />}} key='asesorAnaliticaIndividual' />
                      <ItemList info={{path: '/asesores/analitica/general', name: 'Analítica General', collapse: true, icon: <AnalyticsIcon />}} key='asesorAnaliticaGeneral' />
                    </List>
                  </Collapse>
                </>
              )}
              <ItemList info={{path: '/vista/grupos', name: 'Grupos', icon: <GroupsIcon />}} key='gruposview' />
              <ItemList info={{path: '/procesos', name: 'Procesos', icon: <BallotIcon />}} key='procesos' />
              </List>
            ):(
              <List>
                <ItemList info={{path: '/', name: 'Dashboard', primary: true, icon: <HomeOutlined />}} key='dashboard' />
                <ItemList info={{path: '/contactos', name: 'Potenciales clientes', icon: <Groups2Icon />}} key='contactos' />
                <ItemList info={{path: '/tabla/consultas', name: 'Consultas', icon: <Groups2Icon />}} key='tablaconsultas' />
                <ItemList info={{path: '/pre/servicios', name: 'Pre-Servicios', icon: <PersonPinCircleIcon />}} key='tratos' />
              </List>
            )}
          </Box>
        </Box>
      </Box>
  )
}

export default Sidebar